/* unplugin-vue-components disabled */import { render } from "./website-updates.vue?vue&type=template&id=54821776"
import script from "./website-updates.vue?vue&type=script&lang=js"
export * from "./website-updates.vue?vue&type=script&lang=js"

import "./website-updates.vue?vue&type=style&index=0&id=54821776&lang=scss"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__